module.exports = __webpack_public_path__ + "static/media/shakil  Ahmed Front End Developer.4090df16.pdf";